import { useQuery } from '@tanstack/react-query';
import apiClient from '../services/ApiService';

export const usePropertyDetail = (propertyId) => {
  return useQuery({
    queryKey: ['property', propertyId],
    queryFn: async () => {
      if (!propertyId) return null;
      const response = await apiClient.get(`/api/properties/${propertyId}`);
      return {
        property: response.property,
        bookedDates: response.booked_dates || [],
      };
    },
    enabled: !!propertyId,
    staleTime: 5 * 60 * 1000,
  });
};
